import { isValueLessOperator } from './helpers';
import type { ConditionValueType } from './types';

export type ValueTypeConfig = {
  method: string;
  tagType: Exclude<ConditionValueType, 'date'>;
  convertToDb?: (a: any) => any;
  convertFromDb?: (a: any) => any;
};

export const valuesTypes: ValueTypeConfig[] = [
  {
    method: 'Integer',
    tagType: 'integer',
  },
  {
    method: 'String',
    tagType: 'string',
  },
  {
    method: 'Boolean',
    tagType: 'boolean',
  },
  {
    method: 'List',
    tagType: 'list',
  },
  /*
  {
    method: 'Date',
    tagType: 'date',
    convertToDb: (v: string) => Timestamp.fromDate(parseUTCStringToDate(v)),
    convertFromDb: (t: Timestamp) => formatDateToUTCString(t.toDate()),
  },
  */
  {
    method: 'Price',
    tagType: 'decimal',
  },
  {
    method: 'Version',
    tagType: 'version',
  },
  {
    method: 'Timezone',
    tagType: 'timezone',
  },
];

export type OperatorConfig = {
  method: string;
  operator?: string;
  checkOperator?: (a: string) => boolean;
  getOperator?: (r: any) => string;
};
export const operators: Array<OperatorConfig> = [
  {
    method: 'Eq',
    operator: 'eq',
  },
  {
    method: 'Neq',
    operator: 'noteq',
  },
  {
    method: 'Lte',
    operator: 'lte',
  },
  {
    method: 'Gte',
    operator: 'gte',
  },
  {
    method: 'In',
    operator: 'in',
  },
  {
    method: 'NotIn',
    operator: 'notin',
  },
  {
    method: 'Between',
    operator: 'between',
  },
  {
    method: 'Exists',
    // checkOperator: need when converts for db (toFilterExpression)
    checkOperator: isValueLessOperator as (a: string) => boolean,
    getOperator: (r: any) => (r.getExists() ? 'any' : 'notset'),
  },
];
